module.exports = __webpack_public_path__ + "img/wait_verify.d6cf825f.png";